import type { BrandConfig } from '../types';

/** RoyalX / HeroGames — dark + orange theme. */
export const royalx: BrandConfig = {
  id: 'royalx',
  name: 'HeroGames',
  displayName: 'RoyalX Club',
  title: 'HeroGames',
  colors: {
    // #FF6B00  ->  hsl(25 100% 50%)
    primaryHsl: '25 100% 50%',
    primary: '#FF6B00',
    headerGradient: ['#1A1108', '#0F0F0F'],
    buttonGradient: ['#1a1a1a', '#FF6B00'],
  },
  features: {
    // RoyalX ne abhi ye features enable nahi kiye — flag se off.
    fantasy: false,
    aggregator: false,
    liveCasino: false,
    slots: false,
    downloadApk: false,
  },
  urls: {
    app: import.meta.env.VITE_APP_URL ?? 'https://herogams.fun',
  },
  supportEmail: 'info@herogams.fun',
  /**
   * Placeholder line-up so the "choose your bonus" block renders with real,
   * selectable cards. The wording is deliberately generic: the amounts, the
   * terms and the campaign codes are the operator's to set from the panel, and
   * promising a specific figure here would put an offer in front of players
   * that nobody signed off on. Swap the ids for the real campaign codes.
   */
  signupBonuses: [
    {
      id: 'WELCOME-SPORTS',
      title: 'Sports Welcome Offer',
      subtitle: 'Bonus on your first deposit',
      gradient: ['#7b2ff7', '#2f80ed'],
    },
    {
      id: 'WELCOME-CASINO',
      title: 'Casino Welcome Offer',
      subtitle: 'Free rounds on selected games',
      gradient: ['#f7971e', '#ffd200'],
    },
    {
      id: '',
      title: 'No bonus',
      subtitle: 'Play without a welcome offer',
      gradient: ['#4b4b4b', '#2b2b2b'],
    },
  ],
  assets: {
    logo: '/brands/royalx/logo.png',
    favicon: '/brands/royalx/favicon.ico',
    appleTouchIcon: '/brands/royalx/apple-touch-icon.png',
  },
};
